const TYPE_ICONS = {
  'eb-section': 'fa-columns',
  'eb-row': 'fa-bars',
  'eb-column': 'fa-square-o',
  'eb-heading': 'fa-header',
  'eb-text-editor': 'fa-align-left',
  'eb-image': 'fa-image',
  'eb-button': 'fa-hand-pointer-o',
  'eb-divider': 'fa-minus',
  'eb-spacer': 'fa-arrows-v',
  'eb-video': 'fa-play-circle',
  'eb-icon': 'fa-star',
  'eb-icon-box': 'fa-cube',
  'eb-image-box': 'fa-id-card',
  'eb-counter': 'fa-sort-numeric-asc',
  'eb-countdown': 'fa-clock-o',
  'eb-testimonial': 'fa-quote-left',
  'eb-tabs': 'fa-folder-o',
  'eb-accordion': 'fa-list',
  'eb-alert': 'fa-exclamation-triangle',
  'eb-social-icons': 'fa-share-alt',
  'eb-google-maps': 'fa-map-marker',
  'eb-price-table': 'fa-table',
  'eb-price-list': 'fa-list-ul',
  'eb-flip-box': 'fa-refresh',
  'eb-call-to-action': 'fa-bullhorn',
  'eb-animated-headline': 'fa-text-width',
  'eb-star-rating': 'fa-star',
  'eb-progress-bar': 'fa-tasks',
  'eb-carousel': 'fa-picture-o',
  'eb-gallery': 'fa-th',
  'eb-custom-html': 'fa-code',
  'wrapper': 'fa-file-o',
  'text': 'fa-font',
  'link': 'fa-link',
  'image': 'fa-image',
  'default': 'fa-circle-o',
}

export default function elementorNavigator(editor) {
  let navigatorPanel = null
  let historyPanel = null

  function getTypeIcon(type) {
    return TYPE_ICONS[type] || TYPE_ICONS['default']
  }

  function getDisplayName(component) {
    const customName = component.getName()
    if (customName && customName !== component.get('type')) return customName
    const type = component.get('type') || 'element'
    const tagName = component.get('tagName') || ''
    if (type === 'wrapper') return 'Body'
    if (type === 'text') return 'Text'
    return component.get('name') || type.replace('eb-', '').replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase()) || tagName
  }

  function buildTree(component, depth = 0) {
    const el = document.createElement('div')
    el.className = 'eb-nav-item'
    el.setAttribute('data-cid', component.cid)

    const row = document.createElement('div')
    row.className = 'eb-nav-row'
    row.style.paddingLeft = `${12 + depth * 16}px`

    if (editor.getSelected() === component) {
      row.classList.add('eb-nav-selected')
    }

    const children = component.components()
    const hasChildren = children && children.length > 0
    const isCollapsed = component._navCollapsed

    const toggle = document.createElement('span')
    toggle.className = 'eb-nav-toggle'
    if (hasChildren) {
      toggle.innerHTML = `<i class="fa ${isCollapsed ? 'fa-caret-right' : 'fa-caret-down'}"></i>`
      toggle.addEventListener('click', (e) => {
        e.stopPropagation()
        component._navCollapsed = !component._navCollapsed
        refreshNavigator()
      })
    } else {
      toggle.innerHTML = '<span style="width:10px;display:inline-block;"></span>'
    }
    row.appendChild(toggle)

    const icon = document.createElement('span')
    icon.className = 'eb-nav-icon'
    icon.innerHTML = `<i class="fa ${getTypeIcon(component.get('type'))}"></i>`
    row.appendChild(icon)

    const label = document.createElement('span')
    label.className = 'eb-nav-label'
    label.textContent = getDisplayName(component)
    label.addEventListener('dblclick', (e) => {
      e.stopPropagation()
      label.contentEditable = true
      label.focus()
      const range = document.createRange()
      range.selectNodeContents(label)
      window.getSelection().removeAllRanges()
      window.getSelection().addRange(range)
      label.addEventListener('blur', () => {
        label.contentEditable = false
        const newName = label.textContent.trim()
        if (newName) component.set('name', newName)
      }, { once: true })
      label.addEventListener('keydown', (ev) => {
        if (ev.key === 'Enter') { ev.preventDefault(); label.blur() }
        if (ev.key === 'Escape') { label.textContent = getDisplayName(component); label.blur() }
      })
    })
    row.appendChild(label)

    const actions = document.createElement('span')
    actions.className = 'eb-nav-actions'

    const visBtn = document.createElement('button')
    visBtn.className = 'eb-nav-action'
    const isHidden = component.getStyle().display === 'none'
    visBtn.innerHTML = `<i class="fa ${isHidden ? 'fa-eye-slash' : 'fa-eye'}"></i>`
    visBtn.title = isHidden ? 'Show' : 'Hide'
    visBtn.addEventListener('click', (e) => {
      e.stopPropagation()
      if (isHidden) {
        const style = { ...component.getStyle() }
        delete style.display
        component.setStyle(style)
      } else {
        component.setStyle({ ...component.getStyle(), display: 'none' })
      }
      refreshNavigator()
    })
    actions.appendChild(visBtn)

    const lockBtn = document.createElement('button')
    lockBtn.className = 'eb-nav-action'
    const isLocked = component.get('locked')
    lockBtn.innerHTML = `<i class="fa ${isLocked ? 'fa-lock' : 'fa-unlock'}"></i>`
    lockBtn.title = isLocked ? 'Unlock' : 'Lock'
    lockBtn.addEventListener('click', (e) => {
      e.stopPropagation()
      component.set('locked', !isLocked)
      if (!isLocked) {
        component.set({ draggable: false, droppable: false, editable: false, selectable: true })
      } else {
        component.set({ draggable: true, droppable: undefined, editable: undefined })
      }
      refreshNavigator()
    })
    actions.appendChild(lockBtn)

    row.appendChild(actions)

    row.addEventListener('click', () => {
      editor.select(component)
      const view = component.getEl()
      if (view) view.scrollIntoView({ behavior: 'smooth', block: 'center' })
    })

    row.draggable = true
    row.addEventListener('dragstart', (e) => {
      e.dataTransfer.setData('text/plain', component.cid)
      row.classList.add('eb-nav-dragging')
    })
    row.addEventListener('dragend', () => {
      row.classList.remove('eb-nav-dragging')
    })
    row.addEventListener('dragover', (e) => {
      e.preventDefault()
      row.classList.add('eb-nav-drag-over')
    })
    row.addEventListener('dragleave', () => {
      row.classList.remove('eb-nav-drag-over')
    })
    row.addEventListener('drop', (e) => {
      e.preventDefault()
      row.classList.remove('eb-nav-drag-over')
      const srcCid = e.dataTransfer.getData('text/plain')
      if (srcCid === component.cid) return
      const wrapper = editor.DomComponents.getWrapper()
      const srcComp = findByCid(wrapper, srcCid)
      if (srcComp && srcComp !== component) {
        const parent = component.parent()
        if (parent) {
          const idx = parent.components().indexOf(component)
          srcComp.move(parent, { at: idx })
          refreshNavigator()
        }
      }
    })

    el.appendChild(row)

    if (hasChildren && !isCollapsed) {
      const childContainer = document.createElement('div')
      childContainer.className = 'eb-nav-children'
      children.forEach(child => {
        childContainer.appendChild(buildTree(child, depth + 1))
      })
      el.appendChild(childContainer)
    }

    return el
  }

  function findByCid(component, cid) {
    if (component.cid === cid) return component
    const children = component.components()
    for (let i = 0; i < children.length; i++) {
      const found = findByCid(children.at(i), cid)
      if (found) return found
    }
    return null
  }

  function refreshNavigator() {
    if (!navigatorPanel) return
    const tree = navigatorPanel.querySelector('.eb-nav-tree')
    if (!tree) return
    tree.innerHTML = ''
    const wrapper = editor.DomComponents.getWrapper()
    if (wrapper) {
      wrapper.components().forEach(child => {
        tree.appendChild(buildTree(child, 0))
      })
    }
    if (!wrapper || !wrapper.components().length) {
      tree.innerHTML = '<div style="padding:20px;text-align:center;color:#6c7293;font-size:12px;"><i class="fa fa-sitemap" style="font-size:24px;display:block;margin-bottom:8px;color:#3c3c4a;"></i>No elements on canvas</div>'
    }
  }

  function buildHistoryPanel() {
    const panel = document.createElement('div')
    panel.className = 'eb-history-panel eb-panel-view'
    panel.setAttribute('data-tab', 'history')
    panel.style.display = 'none'

    const header = document.createElement('div')
    header.className = 'eb-hist-header'
    header.innerHTML = `
      <h3 style="margin:0;font-size:14px;font-weight:700;color:#fff;">History</h3>
      <div class="eb-hist-actions">
        <button class="eb-hist-btn" id="eb-hist-undo" title="Undo"><i class="fa fa-undo"></i></button>
        <button class="eb-hist-btn" id="eb-hist-redo" title="Redo"><i class="fa fa-repeat"></i></button>
      </div>
    `
    panel.appendChild(header)

    const list = document.createElement('div')
    list.className = 'eb-hist-list'
    panel.appendChild(list)

    return panel
  }

  function refreshHistory() {
    if (!historyPanel) return
    const list = historyPanel.querySelector('.eb-hist-list')
    if (!list) return
    list.innerHTML = ''

    const um = editor.UndoManager
    if (!um) return

    const stack = um.getStack()
    const pointer = um.getPointer ? um.getPointer() : -1

    if (!stack || !stack.length) {
      list.innerHTML = '<div style="padding:20px;text-align:center;color:#6c7293;font-size:12px;"><i class="fa fa-history" style="font-size:24px;display:block;margin-bottom:8px;color:#3c3c4a;"></i>No history yet</div>'
      return
    }

    stack.forEach((entry, idx) => {
      const item = document.createElement('div')
      item.className = 'eb-hist-item'
      if (idx <= pointer) item.classList.add('eb-hist-active')
      if (idx === pointer) item.classList.add('eb-hist-current')

      const type = entry.get ? entry.get('type') : 'change'
      const icons = {
        add: 'fa-plus',
        remove: 'fa-minus',
        change: 'fa-pencil',
        move: 'fa-arrows',
      }

      item.innerHTML = `
        <span class="eb-hist-icon"><i class="fa ${icons[type] || 'fa-circle-o'}"></i></span>
        <span class="eb-hist-label">${getHistoryLabel(entry, idx)}</span>
        <span class="eb-hist-num">#${idx + 1}</span>
      `

      item.addEventListener('click', () => {
        const diff = idx - pointer
        if (diff > 0) {
          for (let i = 0; i < diff; i++) um.redo()
        } else if (diff < 0) {
          for (let i = 0; i < Math.abs(diff); i++) um.undo()
        }
        refreshHistory()
        refreshNavigator()
      })

      list.appendChild(item)
    })

    list.scrollTop = list.scrollHeight
  }

  function getHistoryLabel(entry, idx) {
    if (idx === 0) return 'Initial state'
    const type = entry.get ? entry.get('type') : ''
    if (type === 'add') return 'Added element'
    if (type === 'remove') return 'Removed element'
    if (type === 'move') return 'Moved element'
    return `Change #${idx}`
  }

  editor.Commands.add('open-navigator', {
    run() {
      const sidebar = document.querySelector('.eb-sidebar-body')
      if (!sidebar) return

      if (!navigatorPanel) {
        navigatorPanel = document.createElement('div')
        navigatorPanel.className = 'eb-navigator-panel eb-panel-view'

        const header = document.createElement('div')
        header.className = 'eb-nav-header'
        header.innerHTML = '<h3 style="margin:0;font-size:14px;font-weight:700;">Navigator</h3><p style="margin:4px 0 0;font-size:11px;color:#adb5bd;">Click to select, drag to reorder</p>'
        navigatorPanel.appendChild(header)

        const tree = document.createElement('div')
        tree.className = 'eb-nav-tree'
        navigatorPanel.appendChild(tree)

        sidebar.appendChild(navigatorPanel)
      }

      sidebar.querySelectorAll('.eb-panel-view').forEach(v => v.style.display = 'none')
      navigatorPanel.style.display = 'block'

      refreshNavigator()
    },
    stop() {
      if (navigatorPanel) navigatorPanel.style.display = 'none'
    },
  })

  editor.Commands.add('open-history', {
    run(editor) {
      const sidebar = document.querySelector('.eb-sidebar-body')
      if (!sidebar) return

      if (!historyPanel) {
        historyPanel = buildHistoryPanel()
        sidebar.appendChild(historyPanel)

        const undoBtn = historyPanel.querySelector('#eb-hist-undo')
        const redoBtn = historyPanel.querySelector('#eb-hist-redo')
        if (undoBtn) undoBtn.addEventListener('click', () => { editor.UndoManager.undo(); refreshHistory(); refreshNavigator() })
        if (redoBtn) redoBtn.addEventListener('click', () => { editor.UndoManager.redo(); refreshHistory(); refreshNavigator() })
      }

      sidebar.querySelectorAll('.eb-panel-view').forEach(v => v.style.display = 'none')
      historyPanel.style.display = 'block'

      refreshHistory()
    },
    stop() {
      if (historyPanel) historyPanel.style.display = 'none'
    },
  })

  editor.on('load', () => {
    editor.on('component:selected', refreshNavigator)
    editor.on('component:deselected', refreshNavigator)
    editor.on('component:add', () => { refreshNavigator(); refreshHistory() })
    editor.on('component:remove', () => { refreshNavigator(); refreshHistory() })
    editor.on('component:update', () => { refreshHistory() })
    editor.on('component:drag:end', () => { refreshNavigator(); refreshHistory() })
  })
}
